import { categories } from "./data";
import { UPDATE } from "./types";


const INITIAL_STATE = {
	// specialty: categories.filter(e => e.sector === "specialty").slice(0,4),
	// condition: categories.filter(e => e.sector === "condition").slice(0,4),
	// procedure: categories.filter(e => e.sector === "procedure").slice(0,4),
	// categories: categories.filter((e, i) => i < 8),
	allcategories: categories
};

export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case UPDATE:
			return {
				...state,
				...action
			};

		default:
			return state;
	}
};


